module.exports = __webpack_public_path__ + "img/drive_driver_off.48e4a175.svg";